import React from 'react';
import { AuditTable } from '@/AdminComponent/ReleaseAudit/components/AuditTable';
import { AuditKpis } from '@/AdminComponent/ReleaseAudit/components/AuditKpis';
import AuditTimeseriesPanel from '@/AdminComponent/ReleaseAudit/components/AuditTimeseriesPanel';

export const ReleaseAudit = () => {
	return (
		<>
			<AuditTable />
			<AuditTimeseriesPanel />
			<AuditKpis />
		</>
	);
};
